import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, FormControl, InputLabel, Select, MenuItem, Box, FormHelperText } from '@mui/material';

const ActivityForm = ({ open, onClose, onSubmit, initialData, title = 'Add Activity', loading = false }) => {
  const [formData, setFormData] = useState({ name: '', date: '', description: '', type: 'holiday' });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (initialData) {
      setFormData({
        name: initialData.name || '',
        date: initialData.date || '',
        description: initialData.description || '',
        type: initialData.type || 'holiday',
      });
    } else {
      setFormData({ name: '', date: '', description: '', type: 'holiday' });
    }
    setErrors({});
  }, [initialData, open]);

  const handleChange = (field) => (e) => {
    const value = e.target.value;
    setFormData(prev => ({ ...prev, [field]: value }));
    if (errors[field]) setErrors(prev => ({ ...prev, [field]: '' }));
  };

  const validate = () => {
    const n = {};
    if (!formData.name.trim()) n.name = 'Name is required';
    if (!formData.date) n.date = 'Date is required';
    if (!formData.type) n.type = 'Type is required';
    setErrors(n);
    return Object.keys(n).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    const payload = { ...formData };
    if (initialData?.id) payload.id = initialData.id;
    await onSubmit(payload);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Box component="form" sx={{ mt: 1 }}>
          <TextField fullWidth margin="normal" label="Name" value={formData.name} onChange={handleChange('name')} error={!!errors.name} helperText={errors.name} required />
          <TextField fullWidth margin="normal" label="Date" type="date" value={formData.date} onChange={handleChange('date')} error={!!errors.date} helperText={errors.date} InputLabelProps={{ shrink: true }} required />
          <FormControl fullWidth margin="normal" error={!!errors.type}>
            <InputLabel>Type</InputLabel>
            <Select value={formData.type} onChange={handleChange('type')} label="Type">
              <MenuItem value="holiday">Holiday</MenuItem>
              <MenuItem value="event">Event</MenuItem>
            </Select>
            {errors.type && <FormHelperText>{errors.type}</FormHelperText>}
          </FormControl>
          <TextField fullWidth margin="normal" label="Description" value={formData.description} onChange={handleChange('description')} multiline rows={3} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained" disabled={loading}>{initialData?.id ? 'Update' : 'Create'}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ActivityForm;


